import { render, staticRenderFns } from "./ResponsiveTable.vue?vue&type=template&id=1ad5608c&scoped=true"
import script from "./ResponsiveTable.vue?vue&type=script&lang=js"
export * from "./ResponsiveTable.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveTable.vue?vue&type=style&index=0&id=1ad5608c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad5608c",
  null
  
)

export default component.exports